import { REWARDS_WIDGET_NAMES } from "@/constants/widget-names";
import {
    RewardsAvailableRewardsB2BPageWidgetModalDefinition,
    RewardsAvailableRewardsPageWidgetModalDefinition,
} from "@apps/rewards/constants/definitions";
import type { RewardsWidgetInjectorConfig } from "@apps/rewards/types";
import WidgetInjectedSdkEvent from "@modules/sdk/common_sdk/events/WidgetInjectedSdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";

import RewardsAvailableRewardsB2bPageWidgetModal from "./b2b/RewardsAvailableRewardsB2bPageWidgetModal";
import RewardsAvailableRewardsPageWidgetModal from "./RewardsAvailableRewardsPageWidgetModal";

interface RewardsAvailableRewardsPageWidgetModalInjectorConfig
    extends RewardsWidgetInjectorConfig {
    isCustomerB2b: boolean;
}

class RewardsAvailableRewardsPageWidgetModalInjector {
    constructor(
        private readonly config: RewardsAvailableRewardsPageWidgetModalInjectorConfig
    ) {}

    start(): void {
        this.config.logger.debug(
            "RewardsAvailableRewardsPageWidgetModalInjector start",
            {
                placeholderSelector: this.config.placeholderSelector,
            }
        );

        const targets$ = this.config.mutationObserverInjector.register({
            targetSelector: this.config.placeholderSelector,
        });

        targets$.subscribe((placeholder) => {
            this.config.logger?.debug(
                "RewardsAvailableRewardsPageWidgetModalInjector found placeholder",
                {
                    placeholder,
                }
            );

            let widget:
                | RewardsAvailableRewardsPageWidgetModal
                | RewardsAvailableRewardsB2bPageWidgetModal;
            let widgetName: REWARDS_WIDGET_NAMES;

            void (async () => {
                if (this.config.isCustomerB2b) {
                    const RewardsAvailableRewardsB2BPageWidgetModal =
                        await this.config.dynamicImportManager.importDefault(
                            RewardsAvailableRewardsB2BPageWidgetModalDefinition
                        );
                    widgetName =
                        REWARDS_WIDGET_NAMES.REWARDS_AVAILABLE_REWARDS_B2B_PAGE_WIDGET_MODAL;
                    widget = new RewardsAvailableRewardsB2BPageWidgetModal(
                        {
                            target: placeholder,
                        },
                        this.config.logger
                    );
                } else {
                    const RewardsAvailableRewardsPageWidgetModal =
                        await this.config.dynamicImportManager.importDefault(
                            RewardsAvailableRewardsPageWidgetModalDefinition
                        );
                    widgetName =
                        REWARDS_WIDGET_NAMES.REWARDS_AVAILABLE_REWARDS_PAGE_WIDGET_MODAL;
                    widget = new RewardsAvailableRewardsPageWidgetModal(
                        {
                            target: placeholder,
                        },
                        this.config.logger
                    );
                }

                await widget.init();

                this.config.eventsCollector.pushEvent(
                    this.config.eventsFactory.createWidgetInjected(widgetName)
                );

                dispatchSdkEvent(new WidgetInjectedSdkEvent(widgetName));
            })();
        });
    }
}

export default RewardsAvailableRewardsPageWidgetModalInjector;
